<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Register Device</div>
    <form @submit.prevent="submit">
      <c-text-input v-model="data.serial" label="Serial" placeholder="xx-xxxx-xxxxxx" :error="errors.serial"/>
      <c-text-input v-model="data.name" label="Name" placeholder="Pump 10" :error="errors.name"/>
      <c-text-input v-model="data.location" label="Location" placeholder="Facility 10" :error="errors.location"/>
      <div class="pt-5">
        <button class="button is-primary is-fullwidth">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/api';


export default {
  name: 'register-form',
  data () {
    return {
      data: {},
      errors: {}
    };
  },
  methods: {
    async submit() {
      try {
        await api.devices.register(this.data.serial, this.data.name, this.data.location);
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle(error);
      }
    },
    handle(error) {
      this.errors = {};
      if (error.status === 404) {
        this.errors.serial = 'This serial is incorrect or is already registered.';
      }
    }
  }
};
</script>
